import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";

export async function requestWithHandler(url, options = {}) {
    try {
        const response = await fetch(url, options);
        if (response.status === 302) {
            const location = response.headers.get('Location');
            if (location) {
                window.location.href = location;
            }
        } else if (response.status >= 500) {
            renderAlertVue('A server error occurred. Please try again later.', 'danger', 5000)
        } else if (response.status === 401) {
            window.location.href = '/signup';
        }
        // Redirect currently not implemented could possibly go wrong somewhere
        // else if (response.status == 200 && response.redirected) {
        //     window.location.href = response.url;
        // }

        return response;
    } catch (error) {
        console.error('Error while performing the request:', error);
        renderAlertVue('A server error occurred. Please try again later.', 'danger', 5000)
        throw error;
    }
}
